import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { RoleService, environment } from '@perval/shared';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private roleService: RoleService,
    private router: Router,
  ) {}

  canActivate(next: ActivatedRouteSnapshot): boolean {
    const expectedRole = next.data['expectedRole'];
    const redirectTo = next.data['redirectTo'];

    for (const role of this.roleService.currentUserRoles) {
      if (expectedRole.includes(role)) {
        return true;
      }
    }

    if (redirectTo) {
      this.router.navigate([redirectTo]);
    } else {
      window.location.href = `${environment.host}/content/accueil`;
    }

    return false;
  }
}
